import { render, staticRenderFns } from "./text-analysis-grid.vue?vue&type=template&id=3a6d8145&scoped=true"
import script from "./text-analysis-grid.ts?vue&type=script&lang=ts&external"
export * from "./text-analysis-grid.ts?vue&type=script&lang=ts&external"
import style0 from "./text-analysis-grid.less?vue&type=style&index=0&id=3a6d8145&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6d8145",
  null
  
)

export default component.exports